import { render } from "./ForeignTradeByRegionsFilter.vue?vue&type=template&id=1f3ae37a&ts=true"
import script from "./ForeignTradeByRegionsFilter.vue?vue&type=script&lang=ts"
export * from "./ForeignTradeByRegionsFilter.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__